'use strict';

angular.module('randomization', [
    'ecrd',
    'ecrd.records',
    'ecrd.sites',
    'gettext',
    'sharecrf-auth',
    'sharecrf-sdk',
    'table-settings',
]);
